import React, { useRef, useState } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { Crop, Maximize } from "lucide-react";

function cropToDataUrl(img, c) {
  const sx = img.naturalWidth / img.width;
  const sy = img.naturalHeight / img.height;
  const k = Math.min(1, 1600 / Math.max(c.width * sx, c.height * sy));
  const canvas = document.createElement("canvas");
  canvas.width = Math.max(1, Math.round(c.width * sx * k));
  canvas.height = Math.max(1, Math.round(c.height * sy * k));
  canvas.getContext("2d").drawImage(img, c.x * sx, c.y * sy, c.width * sx, c.height * sy, 0, 0, canvas.width, canvas.height);
  return canvas.toDataURL("image/jpeg", 0.9);
}

// Lets the user frame only the one sketch they want read.
export const SketchCropper = ({ src, onDone, t }) => {
  const imgRef = useRef(null);
  const [crop, setCrop] = useState({ unit: "%", x: 5, y: 5, width: 90, height: 90 });
  const [px, setPx] = useState(null);

  const apply = () => {
    const img = imgRef.current;
    const full = { x: 0, y: 0, width: img?.width || 0, height: img?.height || 0 };
    if (!img) return;
    onDone(cropToDataUrl(img, !px || px.width < 20 || px.height < 20 ? full : px));
  };

  return (
    <div className="mt-6 border border-amber-500/40 bg-zinc-950 p-4 max-w-3xl space-y-3" data-testid="pipeviz-cropper">
      <div className="text-sm text-amber-300 flex items-center gap-2"><Crop className="w-4 h-4" /> {t.cropTitle}</div>
      <div className="text-xs text-zinc-500">{t.cropHint}</div>
      <div className="flex justify-center bg-black">
        <ReactCrop crop={crop} onChange={(p, pc) => { setCrop(pc); setPx(p); }} onComplete={(p) => setPx(p)} keepSelection ruleOfThirds style={{ maxHeight: "60vh" }}>
          <img ref={imgRef} src={src} alt="sketch" style={{ maxHeight: "60vh", width: "auto" }} data-testid="pipeviz-cropper-img"
               onLoad={(e) => { const i = e.currentTarget; setPx({ unit: "px", x: i.width * 0.05, y: i.height * 0.05, width: i.width * 0.9, height: i.height * 0.9 }); }} />
        </ReactCrop>
      </div>
      <div className="flex flex-wrap gap-3">
        <button onClick={apply} data-testid="pipeviz-crop-apply" className="wb-btn-primary px-5 py-3 text-sm inline-flex items-center gap-2"><Crop className="w-4 h-4" /> {t.cropApply}</button>
        <button onClick={() => { const i = imgRef.current; if (i) onDone(cropToDataUrl(i, { x: 0, y: 0, width: i.width, height: i.height })); }} data-testid="pipeviz-crop-full" className="px-5 py-3 text-sm border border-zinc-700 text-white hover:border-amber-500 transition-colors inline-flex items-center gap-2"><Maximize className="w-4 h-4" /> {t.cropFull}</button>
      </div>
    </div>
  );
};
